import InputWidget from '../../../../lib/InputWidget/InputWidget';
import {
  SPAIN_COUNTRY_CODE,
  SUPPORTED_COUNTRY_LIST,
  UK_COUNTRY_CODE,
} from '../../../../utils/constant';

import {Box, Card, CardContent, TextField} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './BankMandateValidation.css';

import countrySpecificConfig from './BankMandateValidationConfig.json';

const BankMandateValidation = (props) => {
  const {t} = useTranslation();
  const [accountHolderName, setAccountHolderName] = React.useState('');
  const [accountNumber, setAccountNumber] = React.useState('');
  const [iban, setIban] = React.useState('');
  const country = SUPPORTED_COUNTRY_LIST.includes(props.country)
    ? props.country
    : SPAIN_COUNTRY_CODE;
  const [sortCode, setSortCode] = React.useState({
    'textField-part1': '',
    'textField-part2': '',
    'textField-part3': '',
  });

  const handleChange = (e) => {
    const {id, value} = e.target;
    if (value.length <= 2 && /^\d*$/.test(value)) {
      setSortCode({...sortCode, [id]: value});
      if (value.length === 2) {
        const nextInput = document.getElementById(getNextInputId(id));
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
    if (
      sortCode['textField-part1'].length +
        sortCode['textField-part2'].length +
        sortCode['textField-part3'].length ===
      6
    ) {
      props.isSubmitDisabled(false);
    } else {
      props.isSubmitDisabled(true);
    }
  };

  const getNextInputId = (currentId) => {
    switch (currentId) {
      case 'textField-part1':
        return 'textField-part2';
      case 'textField-part2':
        return 'textField-part3';
      default:
        return null;
    }
  };

  const onAccountHolderNameChangeHandler = (value) => {
    setAccountHolderName(value);
  };
  const onAccountNumberChangeHandler = (value) => {
    const cleanedValue = value.replaceAll(/\D/g, '');
    setAccountNumber(cleanedValue);
  };
  const onIbanChangeHandler = (value) => {
    //IBAN can have alphabets and numbers
    setIban(value);
  };
  const formFields = [
    {
      label: 'ACCOUNT_HOLDER_NAME',
      type: 'text',
      required: true,
      id: 'account-holder-name',
      value: accountHolderName,
      setValue: onAccountHolderNameChangeHandler,
      error: accountHolderName.length > 0,
      helperText: 'ACCOUNT_HOLDER_NAME_MANDATORY',
      subText: 'ACCOUNT_HOLDER_NAME_SUBTEXT',
    },
    {
      label: 'ACCOUNT_NUMBER',
      type: 'text',
      required: true,
      id: 'account-number',
      value: accountNumber,
      setValue: onAccountNumberChangeHandler,
      error: accountNumber.length > 0,
      helperText: 'ACCOUNT_NUMBER_MANDATORY',
      subText: 'ACCOUNT_NUMBER_SUBTEXT',
    },
    {
      label: 'IBAN',
      type: 'text',
      required: true,
      id: 'iban',
      value: iban,
      setValue: onIbanChangeHandler,
      error: iban.length > 0,
      helperText: 'IBAN_MANDATORY',
      subText: 'IBAN_SUBTEXT',
    },
  ];

  const getCountryBasedFormFields = (fieldsConfig, countryFields) => {
    const formFields = [];

    for (const countryField of Object.values(countryFields)) {
      formFields.push(
        fieldsConfig.find((fieldConfig) => {
          return fieldConfig.label == countryField;
        })
      );
    }
    return formFields;
  };

  const countryFormFields = getCountryBasedFormFields(
    formFields,
    countrySpecificConfig[country]?.fields
  );

  const validateAccountHolderName = () => {
    for (let key in props.contractDetails) {
      const accountHolder =
        props.contractDetails[key]?.autoPayAuthorization?.bankAccount
          ?.accountHolderName;
      if (accountHolder === accountHolderName) {
        return true;
      }
    }
    return false;
  };

  const validate = () => {
    if (country === UK_COUNTRY_CODE) {
      return (
        accountHolderName.length > 0 &&
        accountNumber.length === countrySpecificConfig[country]?.maxLength &&
        sortCode['textField-part1'].length +
          sortCode['textField-part2'].length +
          sortCode['textField-part3'].length ===
          6
      );
    } else
      return (
        accountHolderName.length > 0 &&
        iban.length === countrySpecificConfig[country]?.maxLength
      );
  };
  React.useEffect(() => {
    if (validate()) {
      let data = {};
      if (country === UK_COUNTRY_CODE) {
        data.newAccountNumber = accountNumber;
        data.newSortCode = Object.values(sortCode).join('');
      } else {
        data.newIban = iban;
      }
      data.newAccountHolderName = accountHolderName;
      props.validAccountHolderName(validateAccountHolderName());
      props.isSubmitDisabled(false, data);
    } else {
      props.isSubmitDisabled(true);
    }
  }, [accountHolderName, accountNumber, iban, sortCode]);

  return (
    <div className={'BankMandateValidationWrapper'}>
      <Box pl={4} pr={4} pb={4}>
        <Card className="cardCustom" key="cardCustom">
          <CardContent className="MandateValidationCard">
            {countryFormFields.map((i, index) => (
              <div key={i.id}>
                <InputWidget
                  required={i.required}
                  type={i.type}
                  id={i.id}
                  label={t(i.label)}
                  value={i.value}
                  setValue={i.setValue}
                  customError={true}
                  error={i.error}
                  helperText={t(i.helperText)}
                />
                <div className={'mandateFieldNote'}>{t(i.subText)}</div>
              </div>
            ))}
            {country === UK_COUNTRY_CODE && (
              <div>
                <label className={'sortCodeLabel'} htmlFor="sortCode">
                  {t('NEW_SORT_CODE')}
                </label>
                <div id="sortCode">
                  <TextField
                    className={'sortCodeText'}
                    id="part1"
                    value={sortCode['textField-part1']}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                  <TextField
                    id="part2"
                    className={'sortCodeText'}
                    value={sortCode['textField-part2']}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                  <TextField
                    id="part3"
                    className={'sortCodeText'}
                    value={sortCode['textField-part3']}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
              </div>
            )}
          </CardContent>
          <div className={'mandateNote'}>{t('NOTE')}</div>
        </Card>
      </Box>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    selectedOrg: state.appStates.selectedOrg,
    userDetails: state.appStates.userDetailsInfo,
  };
};

export default connect(mapStateToProps)(BankMandateValidation);
